import * as React from 'react';
import styled from 'styled-components';

import IViewProps from '../../IViewProps';
import Colors from '../../lib/Colors';
import CardWithHeader from '../CardWithHeader';
import ButtonFooter from '../ButtonFooter';

function UnstyledThankYou(props: IViewProps) {
  const title = props.storeConfirmationTitle || 'Deine Bestellung liegt uns vor!';
  // tslint:disable-next-line:max-line-length
  const message = props.storeConfirmationMessage || 'Bei Prämien kann es ein paar Tage dauern, bis sie in Deinem Postfach landen.';
  const footer = <ButtonFooter>
    <button className="close" onClick={props.onCloseApp}>Weiter mit TVSMILES</button>
  </ButtonFooter>;
  return (
    <CardWithHeader className={props.className} footer={footer}>
      <header className="checkmark-icon">✓</header>
      <header>{title}</header>
      <p>{message}</p>
    </CardWithHeader>
  );
}

const ThankYou = styled(UnstyledThankYou)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  > section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;

    padding: 2rem;
    max-width: 20rem;

    > header {
      font-weight: bold;
    }
  }

  .checkmark-icon {
    width: 4rem;
    height: 4rem;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    font-size: 3rem;
    line-height: 3rem;

    background-color: ${Colors.primary};
    color: white;

    border-radius: 2rem;

    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
`;

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou/ThankYou.tsx